import { render, staticRenderFns } from "./VlIndexDossierCardElement.vue?vue&type=template&id=62c539d9&"
import script from "./VlIndexDossierCardElement.vue?vue&type=script&lang=js&"
export * from "./VlIndexDossierCardElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports